import { Button, Form } from 'react-bootstrap';
import { useContext, useEffect, useRef, useState } from 'react';
import CloseIcon from '../../assets/icon-close.svg?react';
import { SettingContext } from '@/context/SettingContext';
import notify from '@/services/notify';
interface LanguageSelectProps {
  initiated: boolean;
  setInitiated: (boolean) => void;
}
const LanguageSelect = ({ initiated, setInitiated }: LanguageSelectProps) => {
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const { selectedLanguage, setSelectedLanguage, allLanguages, settingsIconRef } =
    useContext(SettingContext);
  const modalRef = useRef<HTMLDivElement | null>(null);
  const closeModalRef = useRef<HTMLButtonElement | null>(null);
  const selectLanguageRef = useRef<HTMLSelectElement | null>(null);

  useEffect(() => {
    if (initiated) {
      setShowLanguageModal(true);
    }
  }, [initiated]);

  useEffect(() => {
    // function to close the modal if clicked outside
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleClose();
      }
    };
    if (showLanguageModal) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleModalKeyDown);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleModalKeyDown);
    };
    //eslint-disable-next-line
  }, [showLanguageModal]);

  useEffect(() => {
    if (closeModalRef.current && showLanguageModal) {
      closeModalRef.current.focus();
    }
  }, [showLanguageModal]);

  const onLanguageSave = (e) => {
    setSelectedLanguage(e.target?.value);
    notify({
      message: 'Your Language has been updated',
      type: 'success',
    });
    handleClose();
  };

  const handleClose = () => {
    setShowLanguageModal(false);
    setInitiated(false);
    settingsIconRef.current?.focus();
  };
  const handleCloseKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Tab' && event.shiftKey && selectLanguageRef.current) {
      event.preventDefault();
      selectLanguageRef.current?.focus();
    }
  };

  const handleModalKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleClose();
    }
  };

  const handleSaveKeyDown = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault();
      closeModalRef.current?.focus();
    }
  };
  return (
    <>
      {showLanguageModal && (
        <div className="chat-menu-src-select" ref={modalRef}>
          <div className="d-flex">
            <div className="ps-2 flex-grow-1" data-testid="data-collection-to-include">
              Change Language
            </div>
            <Button
              className="close-data-collection"
              aria-label="close"
              data-testid="close-select-language-popup"
              title="Close"
              ref={closeModalRef}
              onKeyDown={handleCloseKeyDown}
              onClick={() => {
                handleClose();
              }}
            >
              <CloseIcon />
            </Button>
          </div>
          <div className="d-flex">
            <Form.Select
              aria-label="languages"
              onChange={onLanguageSave}
              data-testid="langauge-dropwdown"
              autoComplete="off"
              defaultValue={selectedLanguage}
              value={selectedLanguage}
              ref={selectLanguageRef}
              onKeyDown={handleSaveKeyDown}
            >
              {allLanguages.map((language) => (
                <option key={language} value={language}>
                  {language}
                </option>
              ))}
            </Form.Select>
          </div>
        </div>
      )}
    </>
  );
};

export default LanguageSelect;
